const loginConstants = {
    login: "Login",
    responseType: "code",
    scope: "user.profile.read",
    logout: "Logout"

}
  
  export default loginConstants;
